<template>
    <v-row>
        <v-col class="col-6 col-lg-2" v-for="(card,index) in data" :key="index">



            <ActionCard
                    style="transform:scale(0.8);"

                    :editable=true
                    :data=card
                    v-on:clicked="actionClicked"
            ></ActionCard>
        </v-col>

    </v-row>
</template>

<script>
    import ActionCard from '../components/ActionCard'

    export default {
        name: "EditAction",
        components:{ActionCard},
        props:{
            "data":Array},
        methods:{
            actionClicked:function(payload){
                this.$emit("actionClicked",payload);
            }
        }
    }
</script>

<style scoped>

</style>
